import * as ajax from '@/helpers/ajax';
import { logger } from '@/helpers/logger';
import { useQuery } from 'react-query';
import { MAGAZINE_ARTICLE_DATA_PATH } from './consts';
import { MagazineArticle, type MagazinArticleJSONItem } from './types';

async function getMagazineArticles(): Promise<MagazineArticle[]> {
  try {
    const data =
      (await ajax.getJsonCached<readonly MagazinArticleJSONItem[]>(
        MAGAZINE_ARTICLE_DATA_PATH
      )) ?? [];

    return data.map((article) => {
      const {
        category,
        contentFormat,
        customerGroup,
        id,
        image,
        path,
        subTitle,
        tags,
        teaserDescription: description,
        title,
      } = article;

      return {
        category,
        contentFormat,
        customerGroup,
        description,
        id,
        image,
        path,
        subTitle,
        tags,
        title,
      };
    });
  } catch (error) {
    logger.error('getMagazineArticles', error);
    return [];
  }
}

export default function useMagazineArticles() {
  return useQuery('magazine-articles', getMagazineArticles);
}
